import { Outlet, Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export default function Layout() {
  const { pathname, hash } = useLocation();

  // When we route from /connect → /start#how-it-works, the browser doesn't
  // auto-scroll to the anchor (React Router only updates the hash). Do it
  // ourselves once the target node is in the DOM.
  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const node = document.getElementById(id);
    if (node) node.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [pathname, hash]);

  // The #how-it-works section lives on the homepage. From `/`, a plain anchor
  // works; from any other page, route to `/#how-it-works` so we navigate
  // first and then scroll.
  const onHome = pathname === '/';
  // The /betterhealth ad landing IS its own talk-to-AI funnel, so the global
  // "Talk to Alfred" nav CTA (which points to the separate /start funnel) is
  // redundant there — hide it on that page only.
  const hideTalkCta = pathname === '/betterhealth';

  return (
    <div className="min-h-screen flex flex-col bg-vita-navy">
      <header className="px-6 py-5 flex items-center justify-between border-b border-stone-900/80">
        <Link to="/" className="flex items-baseline gap-0 leading-none">
          <span className="font-serif text-2xl tracking-tight text-stone-50">Vita</span>
          <span className="font-serif text-2xl tracking-tight text-vita-accent">MD</span>
        </Link>
        <nav className="flex items-center gap-5">
          {onHome ? (
            <a
              href="#how-it-works"
              className="text-sm text-stone-400 hover:text-vita-accent transition"
            >
              How it works
            </a>
          ) : (
            <Link
              to="/#how-it-works"
              className="text-sm text-stone-400 hover:text-vita-accent transition"
            >
              How it works
            </Link>
          )}
          <Link
            to="/media"
            className={`text-sm transition ${
              pathname.startsWith('/media') || pathname.startsWith('/news')
                ? 'text-vita-accent'
                : 'text-stone-400 hover:text-vita-accent'
            }`}
          >
            Media
          </Link>
          {!hideTalkCta && (
            <Link
              to="/betterhealth"
              className="ml-2 inline-flex items-center gap-1 rounded-md bg-vita-accent px-4 py-2 text-sm text-vita-navy font-medium hover:bg-vita-bright transition"
            >
              Talk to Alfred →
            </Link>
          )}
        </nav>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="px-6 py-8 text-center text-xs text-stone-500">
        <p>VitaMD · A Mule Works Inc. company · Private and confidential. Not a substitute for emergency care.</p>
        <p className="mt-1">
          If this is an emergency, call 911. For mental health support, call or text 988.
        </p>
      </footer>
    </div>
  );
}
